import styled from "styled-components";

export const UserToolElement = styled.li`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  gap: 10px;

  &:hover {
    opacity: 0.8;
  }
`;
